import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { getSocialAuthConsent } from './service/index.js';
export const initialConsentState = {
    hasSocialAuthConsent: false,
};
export const getConsentThunk = createAsyncThunk('consent/getConsentThunk', async (_, { rejectWithValue }) => {
    try {
        const socialAuthConsent = await getSocialAuthConsent();
        return socialAuthConsent;
    }
    catch (error) {
        return rejectWithValue(false);
    }
});
export const consentSlice = createSlice({
    name: 'consent',
    initialState: initialConsentState,
    reducers: {
        updateConsent: (state, actions) => {
            state.hasSocialAuthConsent = actions.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConsentThunk.fulfilled, (state, actions) => {
            state.hasSocialAuthConsent = actions.payload;
        })
            .addCase(getConsentThunk.rejected, (state) => {
            state.hasSocialAuthConsent = false;
        });
    },
});
const consentSelector = (state) => state.core.consent;
export const { updateConsent } = consentSlice.actions;
export const hasSocialAuthConsent = createSelector(consentSelector, ({ hasSocialAuthConsent }) => hasSocialAuthConsent);
export default consentSlice.reducer;
//# sourceMappingURL=consentSlice.js.map